import React from "react";
import TableSelector from "../../../components/tables/TableSelector";
import ppp from "../../../components/tables/ppp";

const data = [
  {
    les: "31",
    table: ppp
  }
];

export default () => (
  <TableSelector defaultChapter="31" data={data} title="PPP" />
);



// WEBPACK FOOTER //
// ./src/pages/spqr/rijtjes/ppp.js